export const KEY_PROMO_COOKIE = 'lt-show-promo-banner';
export const PROMO_LINK = 'https://promo.level.travel/cashback-7';
